import React from 'react';
import { Button } from '../common';

export default function CustomerSelector({
  customerSearchTerm,
  showCustomerDropdown,
  filteredCustomers,
  selectedCustomerId,
  hasPaymentRestriction,
  error,
  customerSearchRef,
  customerDropdownRef,
  onSearchChange,
  onCustomerSelect,
  onSearchKeyDown,
  onFocus,
  onAddCustomer,
  onEditCustomer,
  onViewCustomer,
  t,
}) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {t.customer} <span className="text-red-500">*</span>
      </label>

      <div className="flex flex-col gap-2">
        <div className="relative w-full" ref={customerDropdownRef}>
          <input
            ref={customerSearchRef}
            type="text"
            value={customerSearchTerm}
            onChange={onSearchChange}
            onFocus={onFocus}
            onKeyDown={onSearchKeyDown}
            placeholder={'חפש לקוח לפי שם, טלפון או אימייל'}
            disabled={hasPaymentRestriction}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />

          {showCustomerDropdown && filteredCustomers.length > 0 && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
              {filteredCustomers.map((customer) => (
                <div
                  key={customer.id}
                  onClick={() => onCustomerSelect(customer)}
                  className="px-3 py-2 cursor-pointer hover:bg-gray-50 border-b border-gray-100 last:border-b-0"
                >
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-medium text-gray-900">{customer.full_name}</p>
                      <p className="text-sm text-gray-600">{customer.phone}</p>
                    </div>
                    {customer.email && (
                      <p className="text-xs text-gray-500">{customer.email}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {showCustomerDropdown && customerSearchTerm.trim() && filteredCustomers.length === 0 && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
              <div className="px-3 py-2 text-gray-500 text-center">
                {t.noCustomersFound || 'No customers found'}
              </div>
            </div>
          )}
        </div>

        <div className="flex gap-2 shrink-0">
          <Button
            type="button"
            variant="secondary"
            onClick={onAddCustomer}
            className="whitespace-nowrap px-3 py-2 h-[42px]"
            title="הוסף לקוח חדש"
          >
            + הוסף לקוח
          </Button>

          {selectedCustomerId && (
            <Button
              type="button"
              variant="secondary"
              onClick={onEditCustomer}
              className="whitespace-nowrap px-3 py-2 h-[42px]"
              title="ערוך פרטי לקוח"
            >
              ✏️ ערוך לקוח
            </Button>
          )}

          {selectedCustomerId && (
            <Button
              type="button"
              variant="secondary"
              onClick={onViewCustomer}
              className="whitespace-nowrap px-3 py-2 h-[42px]"
              title="פתח תיק לקוח"
            >
              📂  צפה בתיק לקוח
            </Button>
          )}
        </div>
      </div>

      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
